const insuranceFieldName = 'insurance-terms-checkbox-insurance-';

export { insuranceFieldName };
